import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./utils/vant.js";
import vueEsign from 'vue-esign'
Vue.use(vueEsign)


// import VueSignature from "vue-signature-pad";

Vue.config.productionTip = false;
// Vue.use(VueSignature);

new Vue({
  router,
  // VueSignature,
  render: (h) => h(App),
}).$mount("#app");
